
export const name = "pricing-pages-ui";
export const version = "dev";
